import { PropsWithChildren } from 'react'
import { StyledRootBox } from '../styled'

export const RootBox: React.FC<PropsWithChildren> = ({ children }) => {
  return <StyledRootBox className="root-box">{children}</StyledRootBox>
}
